module.exports = __webpack_public_path__ + "static/media/3.0560e1ba.svg";